export default __webpack_public_path__ + "static/media/PAVI-PAMA-LOGO-blue.be2ead9d.png";